// @theme component
import React from 'react';
import { useTranslations } from '@core/js/hooks/i18n';
import BlockingTimer from '@theme/js/components/main/SmsVerification/components/BlockingTimer/BlockingTimer';

import style from './index.scss';

type ErrorMessageProps = {
    error: string,
    useTKey?: boolean,
    timerTillMs?: number,
    timerEndCallback?: () => void
}

const ErrorMessage = React.memo(({ error, useTKey = true, timerTillMs = 0, timerEndCallback }: ErrorMessageProps) => {
    const t = useTranslations('playtech.mobile.system.verification.');
    const errorMessage = useTKey ? t(error) : error;
    const timerDuration = timerTillMs - Date.now();

    if (!error) {
        return null;
    }

    return (
        <span className={style.errorMessage}>
            {errorMessage}
            {timerTillMs > 0 && <BlockingTimer timerDurationMs={timerDuration} timerEndCallback={timerEndCallback}/> }
        </span>
    );
});

export default ErrorMessage;
